export const COMPLETION_METHOD = {
  DOCUSIGN: "DOCUSIGN",
  PAUSED_FOR_CONTRACTING: "PAUSED_FOR_CONTRACTING",
  WAITING_FOR_CARRIER_RESPONSE: "WAITING_FOR_CARRIER_RESPONSE",
  CARRIER_URL: "CARRIER_URL",
  AGENT_OR_INSURED: "AGENT_OR_INSURED",
  AGENT_ONLY: "AGENT_ONLY",
  CONTINUE_TO_COMPLETED_STEP: "CONTINUE_TO_COMPLETED_STEP",
};

export const AUTO_SUBMIT_COMPLETION_METHODS = [
  COMPLETION_METHOD.CARRIER_URL,
  COMPLETION_METHOD.AGENT_OR_INSURED,
  COMPLETION_METHOD.AGENT_ONLY,
];

export type CompletionMethod =
  (typeof COMPLETION_METHOD)[keyof typeof COMPLETION_METHOD];
